module.exports = __webpack_public_path__ + "img/抽奖背景.62a8385a.png";